import * as React from 'react'
function SvgFlash(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M23.4 4h-7.6c-.8 0-1.6.6-2 1.4l-4 14c-.4 1.4.6 2.6 1.8 2.6H19l-3 14 14.6-18.8c1-1.2 0-3.2-1.6-3.2h-6l2.2-7.4c.4-1.4-.6-2.6-1.8-2.6z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgFlash
